import {
  MdElectricBolt,
  MdPlumbing,
  MdFormatPaint,
  MdBuild,
  MdHomeRepairService,
  MdYard,
} from "react-icons/md";
import { GiPlunger, GiWoodFence } from "react-icons/gi";
import { FaHammer } from "react-icons/fa";

export const services = [
  {
    name: "Electrical",
    icon: MdElectricBolt, // Icon for Electrical
    subcategories: [
      "Change sockets",
      "Change light fittings",
      "Change smoke alarms",
      "Rehead appliances",
    ],
  },
  {
    name: "Plumbing",
    icon: GiPlunger, // Icon for Plumbing
    subcategories: [
      "Appliance installation",
      "Bleed radiators",
      "Replace radiators",
      "Replace taps",
      "Install garden taps",
      "Unblock drains",
    ],
  },
  {
    name: "Decoration",
    icon: MdFormatPaint, // Icon for Decoration
    subcategories: [
      "Tiling floors, walls and window sills",
      "Laminate flooring",
      "Small paint jobs (interior & exterior)",
    ],
  },
  {
    name: "Fitting",
    icon: MdBuild, // Icon for Fitting
    subcategories: [
      "Blinds",
      "Curtain poles",
      "Stair rails",
      "Shower screens",
      "Radiator covers",
    ],
  },

  {
    name: "Garden",
    icon: MdYard, // Icon for Garden Work
    subcategories: [
      "Clearance",
      "Small tree or bush removal",
      "Cutting and trimming",
      "Fence painting",
      "Fence panel replacement",
    ],
  },
  {
    name: "General",
    icon: MdHomeRepairService, // Icon for General Work
    subcategories: [
      "Hang pictures",
      "Hang mirrors",
      "Flat pack furniture assembly",
      "...plus much more",
    ],
  },
];


